"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils");

var daysPerWeek = [0, 1, 2, 3, 4, 5, 6, 7];
var hoursPerWeek = [0, 1, 2, 3, 4, 5, 6, "7 or more"];
var agreeDisagree = ["Strongly disagree", "Disagree", "Slightly disagree", "Neither agree nor disagree", "Slightly agree", "Agree", "Strongly agree"];
var questions = screenersImport.expandscreeners([{
  prompt: "This questionnaire will help us to measure your progress, " + "and help you understand how you compare to other people. " + "We are committed to confidentiality and won't ever use your responses in a way that could identify you.",
  type: "multi",
  options: {
    options: [],
    reversed: false
  },
  optional: true,
  aggregated: true,
  batteryId: "survey"
}, utils.screeners.PSS_DEPRECATED, // ROI measures (based on HPQ) - 3 questions
{
  prompt: "On how many days in the last week did your stress levels cause you" + " to miss work or leave you unable to carry out your normal daily duties?",
  extraText: "",
  type: "multi",
  options: daysPerWeek,
  batteryId: "survey"
}, {
  prompt: "On how many days in the last week did you feel so impaired by stress," + " that even though you went to work, your productivity was reduced?",
  extraText: "",
  type: "multi",
  options: daysPerWeek,
  batteryId: "survey"
}, {
  prompt: "How many hours per day do you feel your work is unproductive?",
  extraText: "",
  type: "multi",
  options: hoursPerWeek,
  batteryId: "survey"
}, utils.screeners.WHO5, // Workplace Questionnaire - 5 questions
{
  prompt: "I feel satisfied with my job",
  extraText: "",
  type: "multi",
  options: agreeDisagree,
  batteryId: "survey"
}, {
  prompt: "I feel secure in my job (I will still have a job in a year from now)",
  extraText: "",
  type: "multi",
  options: agreeDisagree,
  batteryId: "survey"
}, {
  prompt: "I am appropriately recognised for the work I do",
  extraText: "",
  type: "multi",
  options: agreeDisagree,
  batteryId: "survey"
}, {
  prompt: "I am happy with the financial rewards for the work I do",
  extraText: "",
  type: "multi",
  options: agreeDisagree,
  batteryId: "survey"
}, {
  prompt: "I feel burnt out because of my work",
  extraText: "",
  type: "multi",
  options: agreeDisagree,
  batteryId: "survey"
}, // NPS
{
  prompt: "How likely are you to recommend your company to a friend as a great place to work?",
  extraText: "",
  type: "multi",
  options: ["0 - Not at all likely", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "10 - Extremely likely"],
  batteryId: "survey"
}, // Finally, we just need some information about your role.
// Again, we won't be sending anything to your employer that identifies you personally.
// We only send reports with data averages and never your individual responses.
{
  prompt: "What is your gender?",
  type: "multi",
  options: ["Male", "Female", "Other"],
  batteryId: "survey"
}, {
  prompt: "How old are you?",
  type: "multi",
  options: ["0-25", "26-30", "31-35", "36-40", "41-45", "46-50", "51-55", "56-60", "61-65", "65+"],
  batteryId: "survey"
}, {
  prompt: "What role / category of work best describes where you spend 70% or more of your time?",
  extraText: "(optional)",
  type: "single",
  optional: true,
  batteryId: "survey"
}]);

var analysis = function analysis(answers) {
  if (!answers) return null;
  var pssScore = 0;
  var who5Score = 0; // PSS Questions

  for (var j = 1; j < 11; j++) {
    pssScore += answers[j];
  } // WHO5 Questions


  for (j = 14; j < 19; j++) {
    who5Score += answers[j];
  } // Make out of 100


  who5Score = Math.round(who5Score * 4);
  pssScore = Math.round(pssScore * 2.5);
  return {
    WHO5: who5Score,
    PSS: pssScore,
    absenteeismDays: answers[11],
    presenteeismDays: answers[12],
    unproductiveHours: answers[13]
  };
};

module.exports = {
  questions: questions,
  analysis: analysis
};